const moment = require('moment');

class FormattersService {
  formatDate(dateStr) {
    return moment(dateStr).format('MMM D, YYYY');
  }
}

const formattersService = new FormattersService();

export default formattersService;
